var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowOutward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.99 3.39875L2.09004 12.2987C1.90671 12.4821 1.67337 12.5737 1.39004 12.5737C1.10671 12.5737 0.873372 12.4821 0.690039 12.2987C0.506706 12.1154 0.415039 11.8821 0.415039 11.5987C0.415039 11.3154 0.506706 11.0821 0.690039 10.8987L9.59004 1.99875H1.99004C1.70671 1.99875 1.46921 1.90292 1.27754 1.71125C1.08587 1.51958 0.990039 1.28208 0.990039 0.998749C0.990039 0.715415 1.08587 0.477915 1.27754 0.286249C1.46921 0.0945821 1.70671 -0.00125122 1.99004 -0.00125122H11.99C12.2734 -0.00125122 12.5109 0.0945821 12.7025 0.286249C12.8942 0.477915 12.99 0.715415 12.99 0.998749V10.9987C12.99 11.2821 12.8942 11.5196 12.7025 11.7112C12.5109 11.9029 12.2734 11.9987 11.99 11.9987C11.7067 11.9987 11.4692 11.9029 11.2775 11.7112C11.0859 11.5196 10.99 11.2821 10.99 10.9987V3.39875Z",
    fill: "#2773B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOutward);
export default __webpack_public_path__ + "static/media/arrow_outward.198eb252aabb1f9fe2a944162add656b.svg";
export { ForwardRef as ReactComponent };